import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { IShowing, IAgentMatch, IShowingCreate, IListingMatched, IShowingPostForm } from '../../../models/showing';
import { ShowingsRestfulDelegate } from '../../../services/DataDelegate/ShowingsDelegate/showings.restful.delegate';
import { ShowingsListDelegate } from '../../../services/DataDelegate/ShowingsDelegate/showings.list.delegate';
import { ShowingsAgentAutoDelegate } from '../../../services/DataDelegate/ShowingsDelegate/showings.agent.automatch';
import CreateAgent from '../../../shared/CreateAgent/create.agent.vue';
import * as T_T from 'cryface';
import * as moment from 'moment';
import { CommonConfig } from '../../../configs/config.common';

@Component({
   components: {
      CreateAgent
   }
})
export default class ShowingsHeader extends Vue {
   public title: string = 'ShowingsHeader';
   public modalCreate: boolean = false;
   public createAgentModal: boolean = false;
   public showingAgentAutoMathDelegate = new ShowingsAgentAutoDelegate();
   public showingRestfulDelegate = new ShowingsRestfulDelegate();
   public showingListDelegate = new ShowingsListDelegate();
   public commonConfig = new CommonConfig();

   public createNewShowingLoading = false;

   public status = [
      'Unconfirmed',
      'Confirmed',
      'Cancelled',
      'FeedbackPending'
   ];

   public formInline = {
      address: '',
      listingAgent: '',
      showingAgent: ''
   };
   public ruleInline = {
      address: [
         { type: 'string', trigger: 'blur' }
      ],
      listingAgent: [
         { type: 'string', trigger: 'blur' }
      ],
      showingAgent: [
         { type: 'string', trigger: 'blur' }
      ]
   };

   public agentForm: IAgentMatch = {
      id: -1,
      phone: '',
      name: '',
      mobile: '',
   };

   public showingToCreate: IShowingCreate = {
      addressOrName: '',
      addressOrName2: '',
      from: '',
      callback: '',
      type: '',
      showingDate: '',
      showingTime: '',
      message: '',
      listing_id: -1
   };

   public instruction: string = '';

   public ruleShowing = {
      addressOrName: [
         { message: 'is empty', validator: this.aOrNameValidator },
      ],
      type: [
         { message: 'is empty', validator: this.msgTypeValidator },
      ],
      from: [
         { message: 'is empty', validator: this.fromValidator },
      ],
      callback: [
         { message: 'is empty', validator: this.callbackNumberValidator },
      ],
      showingTime: [
         { message: 'time or period invalid.', validator: this.timeValidator, trigger: 'blur' }
      ]
   };

   public fromAgent: IAgentMatch = {
      id: -1,
      phone: '',
      name: '',
      mobile: ''
   };

   public typeList = [
      {
         label: 'Showing Request',
         value: 'showing_request'
      },
      {
         label: 'Other Message',
         value: 'other_message'
      }
   ];

   public isAddress = false;

   public addrOrNameTile = 'Addr/Name';

   public addressOrName2Tile = 'Agents';

   public agentMatched: IAgentMatch[] = [];

   public agentMatchedFrom: IAgentMatch[] = [];

   public listingMatched: IListingMatched[] = [];

   public showingDatesSelector: any[] = [];

   public created() {
      const currentDate = new Date();
      for (let i = 0; i < 15; i++) {
         const day = moment(currentDate).add(i, 'days').format(this.commonConfig.dateFormat);
         const weekday = moment(currentDate).add(i, 'days').weekday();
         this.showingDatesSelector.push({ key: i, value: `${this.commonConfig.weekdays[Number(weekday)]}, ${day}` });
      }
   }

   public checkAllStatus() {
      this.status = [
         'Unconfirmed',
         'Confirmed',
         'Cancelled',
         'FeedbackPending'
      ];
   }

   @Watch('showingToCreate.addressOrName', { immediate: true, deep: true })
   public async onAddressOrNameChange(val: any, oldVal: any) {
      if (val.trim().length === 5 || val.trim().length === 9) {
         await this.showingAgentAutoMathDelegate.agentMatch(val);
         const data = this.showingAgentAutoMathDelegate.Data;
         this.listingMatched = data.agentList;
         if (T_T.simpleDetect(data.type)) {
            this.isAddress = data.type === 'address' ? true : false;
         } else {
            this.isAddress = false;
         }
         if (!this.isAddress) {
            this.agentMatched = this.listingMatched[0].agents;
            this.showingToCreate.listing = this.listingMatched[0];
            this.addrOrNameTile = 'Agent';
         } else {
            this.agentMatched = [];
            this.addrOrNameTile = 'Address';
         }
      }
   }

   @Watch('showingToCreate.from', { immediate: true, deep: true })
   public async onFromFieldChange(val: any, oldVal: any) {
      if (val.trim().length === 3 || val.trim().length === 5) {
         await this.showingAgentAutoMathDelegate.agentMatch(val);
         const data = this.showingAgentAutoMathDelegate.Data;
         this.listingMatched = data.agentList;
         if (T_T.simpleDetect(data.type)) {
            if (data.type === 'address') {
               this.agentMatchedFrom = [];
            } else {
               this.agentMatchedFrom = this.listingMatched[0].agents;
            }
         } else {
            this.agentMatchedFrom = this.listingMatched[0].agents;
         }
      }
   }

   public vForAddrOrNameFilterMethod(agents: IAgentMatch[], value: string) {
      if (T_T.simpleDetect(agents)) {
         return agents.filter((agent: IAgentMatch) => {
            if (T_T.simpleDetect(agent.name)) {
               return agent.name.toUpperCase().trim().indexOf(value.toUpperCase().trim()) !== -1;
            } else {
               return false;
            }
         }).slice(0, 10);
      } else {
         return [];
      }
   }

   public vForListingAddressFilterMethod(lisings: IListingMatched[], value: any) {
      if (T_T.simpleDetect(lisings)) {
         return lisings.filter((listing: IListingMatched) => {
            if (T_T.simpleDetect(listing.addr)) {
               return listing.addr.toUpperCase().trim().indexOf(value.toUpperCase().trim()) !== -1;
            } else {
               return false;
            }
         }).slice(0, 10);
      } else {
         return [];
      }
   }

   public onListingAddressSelected(value: any) {
      this.showingToCreate.addressOrName = value;
      this.showingToCreate.listing = this.listingMatched.filter((listing: IListingMatched) => listing.addr === this.showingToCreate.addressOrName)[0];
      this.showingToCreate.listing_id = this.showingToCreate.listing.listingId;
      this.instruction = T_T.simpleDetect(this.showingToCreate.listing.instruction) ? this.showingToCreate.listing.instruction : 'Not Applicable';
      this.agentMatched = this.showingToCreate.listing.agents;
      this.showingToCreate.agent = {
         id: -1,
         name: '',
         phone: '',
         mobile: ''
      };
      this.showingToCreate.type = 'showing_request';
   }

   public onAgentSelected(value: any) {
      this.showingToCreate.addressOrName = value;
      this.showingToCreate.agent = this.agentMatched.filter((agent: IAgentMatch) => agent.name === this.showingToCreate.addressOrName)[0];
      this.showingToCreate.type = 'other_message';
   }

   public onFromAgentSelected(value: any) {
      this.showingToCreate.from = value;
      this.fromAgent = this.agentMatchedFrom.filter((agent: IAgentMatch) => agent.name === this.showingToCreate.from)[0];
   }

   public async handleSearch() {
      this.$store.commit('showingStartFetching');
      this.showingListDelegate.FilterParams = {
         address: this.formInline.address,
         listingAgent: this.formInline.listingAgent,
         showingAgent: this.formInline.showingAgent,
         status: this.status
      };
      await this.showingListDelegate.searchShowings();
      this.$store.commit('updateShowings');
      this.$store.commit('showingEndFetching');
   }


   public async handleResetSearch() {
      this.$store.commit('showingStartFetching');
      this.status = [
         'Unconfirmed',
         'Confirmed',
         'Cancelled',
         'FeedbackPending'
      ];
      this.showingListDelegate.FilterParams = {
         address: '',
         listingAgent: '',
         showingAgent: '',
         status: this.status
      };
      await this.showingListDelegate.searchShowings();
      this.$store.commit('updateShowings');
      this.$store.commit('showingEndFetching');
   }

   public async newShowingCreate() {
      this.createNewShowingLoading = true;
      const form: any = this.$refs['showingToCreate'];
      const result = await new Promise((resolve, reject) => {
         form.validate(async (valid: any) => {
            if (valid) {
               const postForm: IShowingPostForm = {
                  toAgentId: this.showingToCreate.agent!.id,
                  fromAgentId: this.fromAgent.id,
                  smsContent: this.showingToCreate.message,
                  fromAgentName: this.fromAgent.name,
                  callback: this.showingToCreate.callback,
                  smsType: this.showingToCreate.type,
                  listingId: this.showingToCreate.listing_id,
                  showingTime: this.showingToCreate.showingTime,
                  showingDate: '2019-04-30',
                  operator: 'test',
                  operatorId: '1234'
               };
               this.$store.commit('showingStartFetching');
               await this.showingRestfulDelegate.createShowing(postForm);
               await this.showingListDelegate.searchShowings(1);
               this.$store.commit('updateShowings');
               this.$store.commit('showingEndFetching');
               this.$Notice.success(
                  {
                     title: 'Success',
                     desc: `Messages Sent.`
                  }
               );
               resolve(1);
            } else {
               this.$Message.error('Form Validation Failed');
               reject(0);
            }
         });
      });
      form.resetFields();
      this.modalCreate = false;
      this.createNewShowingLoading = false;
   }

   public newShowingCancel() {
      this.showingToCreate = {
         addressOrName: '',
         addressOrName2: '',
         from: '',
         callback: '',
         type: '',
         showingDate: '',
         showingTime: '',
         message: '',
         listing_id: -1
      };
      this.modalCreate = false;
      this.isAddress = false;
      this.listingMatched = [];
      this.agentMatched = [];
      this.agentMatchedFrom = [];
      const table: any = this.$refs['showingToCreate'];
      table.resetFields();
      this.$Message.warning('Create Cancelled');
   }

   public aOrNameValidator(rule: any, value: any, callback: any) {
      if (!T_T.simpleDetect(value)) {
         return callback(new Error('Address Or Name Is Empty'));
      } else {
         callback();
      }
   }

   public msgTypeValidator(rule: any, value: any, callback: any) {
      if (!T_T.simpleDetect(value)) {
         return callback(new Error('Type Is Empty'));
      } else {
         callback();
      }
   }

   public fromValidator(rule: any, value: any, callback: any) {
      if (!T_T.simpleDetect(value) && this.showingToCreate.type === 'showing') {
         return callback(new Error('Agent who requests showing Is Empty'));
      } else {
         callback();
      }
   }

   public callbackNumberValidator(rule: any, value: any, callback: any) {
      if (!T_T.simpleDetect(value) && this.showingToCreate.type === 'showing') {
         return callback(new Error('Callback Number Is Empty'));
      } else {
         callback();
      }
   }

   public timeValidator(rule: any, value: string, callback: any) {
      const regexOne = /[0-9]+(a|p)-[0-9]+(a|p)/; // 1p-2p
      const regexTwo = /[0-9]+-[0-9]+/; // 1130- 1230
      const regexThree = /[0-9]+:[0-9]+ (AM|PM) - [0-9]+:[0-9]+ (AM|PM)/;
      if (!T_T.simpleDetect(value)) {
         return callback(new Error('Time or period invalid'));
      } else {
         if (T_T.isMatchRegex(value.trim(), regexOne)) {
            const timestamps = value.trim().split('-');
            const fromUnit = timestamps[0][timestamps[0].length - 1];
            const toUnit = timestamps[1][timestamps[1].length - 1];
            const from = this._interpretTimeStamp(timestamps[0].substring(0, timestamps[0].length - 1), fromUnit);
            const to = this._interpretTimeStamp(timestamps[1].substring(0, timestamps[1].length - 1), toUnit);
            this.showingToCreate.showingTime = `${from} - ${to}`;
            if (moment(to, 'hh:mm A').diff(moment(from, 'hh:mm A'), 'minute') > 0) {
               return callback();
            } else {
               return callback(new Error('Time or period invalid'));
            }
         } else if (T_T.isMatchRegex(value.trim(), regexTwo)) {
            const timestamps = value.trim().split('-');
            const from = this._interpretTimeStamp(timestamps[0]);
            const to = this._interpretTimeStamp(timestamps[1]);
            this.showingToCreate.showingTime = `${from} - ${to}`;
            if (moment(to, 'hh:mm A').diff(moment(from, 'hh:mm A'), 'minute') > 0) {
               return callback();
            } else {
               return callback(new Error('Time or period invalid'));
            }
         } else if (T_T.isMatchRegex(value.trim(), regexThree)) {
            return callback();
         } else {
            return callback(new Error('Time or period invalid'));
         }
      }
   }

   private _interpretTimeUnit(unit: string) {
      switch (unit.trim().toLocaleLowerCase()) {
         case 'a': return 'AM';
         case 'p': return 'PM';
      }
   }

   private _interpretTimeStamp(stamp: string, unit = '') {
      switch (stamp.length) {
         case 1: {
            if (T_T.simpleDetect(unit)) {
               return `${stamp}:00 ${this._interpretTimeUnit(unit)}`;
            } else {
               return `${stamp}:00 PM`;
            }
         }
         case 2: {
            if (T_T.simpleDetect(unit)) {
               return `${stamp}:00 ${this._interpretTimeUnit(unit)}`;
            } else {
               const hour = Number(stamp) - 12;
               if (hour === 12) {
                  return '12:00 AM';
               } else if (hour === 0) {
                  return `12:00 PM`;
               } else {
                  if (hour > 0) {
                     return `${hour}:00 PM`;
                  } else {
                     return `${hour + 12}:00 PM`;
                  }
               }
            }
         }
         case 3: {
            if (T_T.simpleDetect(unit)) {
               return `${stamp[0]}:${stamp.substring(1, 3)} ${this._interpretTimeUnit(unit)}`;
            } else {
               return `${stamp[0]}:${stamp.substring(1, 3)} PM`;
            }
         }
         case 4: {
            if (T_T.simpleDetect(unit)) {
               return `${stamp.substring(0, 2)}:${stamp.substring(2, 4)} ${this._interpretTimeUnit(unit)}`;
            } else {
               const hour = Number(stamp.substring(0, 2)) - 12;
               if (hour === 12) {
                  return `12:${stamp.substring(2, 4)} AM`;
               } else if (hour === 0) {
                  return `12:${stamp.substring(2, 4)} PM`;
               } else {
                  if (hour > 0) {
                     return `${hour + 12}:${stamp.substring(2, 4)} PM`;
                  } else {
                     return `${hour + 12}:${stamp.substring(2, 4)} PM`;
                  }
               }
            }
         }
      }
   }

   public async callbackOnAgentCreated() {
      this.createAgentModal = false;
      this.isAddress = false;
      this.agentForm = {
         id: -1,
         phone: '',
         name: '',
         mobile: '',
      };
      this.$Notice.success(
         {
            title: 'Success',
            desc: `Agent Create Succeed.`
         }
      );
   }

   public async callbackOnAgentCancelled() {
      this.createAgentModal = false;
      this.isAddress = false;
      this.agentForm = {
         id: -1,
         phone: '',
         name: '',
         mobile: '',
      };
      this.$Notice.error(
         {
            title: 'Cancel',
            desc: `Agent Update Cancelled.`
         }
      );
   }

   public onAgentEdit(id: number) {
      this.agentForm = this.agentMatched.find((agent: IAgentMatch) => agent.id === id)!;
      this.createAgentModal = true;
   }

   public onAgentEditFrom(id: number) {
      this.agentForm = this.agentMatchedFrom.find((agent: IAgentMatch) => agent.id === id)!;
      this.createAgentModal = true;
   }

   public destroyed() {
      this.showingAgentAutoMathDelegate.clearData();
      this.showingListDelegate.clearData();
      this.showingRestfulDelegate.clearData();
   }
}
